import {
  PANDA_REFACTOR_EXPERIMENT_NAME,
  PANDA_REFACTOR_EXPERIMENT_SLUGS,
} from './pandaRefactor/constants';

import type {
  ExperimentConfig,
  PaidRoundupExperimentConfig,
  ReviewExperimentConfig,
  RoundupExperimentConfig,
} from './types';

export const STATIC_EXPERIMENTS: (
  | ExperimentConfig
  | RoundupExperimentConfig
  | PaidRoundupExperimentConfig
  | ReviewExperimentConfig
)[] = [
  {
    pageType: 'roundup',
    slugs: PANDA_REFACTOR_EXPERIMENT_SLUGS,
    name: PANDA_REFACTOR_EXPERIMENT_NAME,
  },
  {
    pageType: 'paid-roundup',
    slugs: PANDA_REFACTOR_EXPERIMENT_SLUGS,
    name: PANDA_REFACTOR_EXPERIMENT_NAME,
  },
  // Commented out because of Best of Awards Experiment
  // {
  //   pageType: 'roundup',
  //   slugs: LAZY_LOAD_ROUNDUPS_EXPERIMENT_SLUGS,
  //   name: LAZY_LOAD_ROUNDUPS_EXPERIMENT_NAME,
  // },
];
